import { addPlaidLinkCallback } from 'services/api';

export const getDomain = () => {
  let { hostname } = window.location;
  if (hostname === 'localhost') {
    hostname = 'contact.tifle.com';
  }
  hostname = hostname.replace('-cms', '');
  hostname = hostname.replace('-dev', '');
  hostname = hostname.replace('-staging', '');
  return hostname;
};

export const getLastSegment = (url: string) => {
  if (!url) {
    return null;
  }
  return url.substring(url.lastIndexOf('/') + 1);
};

export const downloadLink = (targetLink: string, fileName: string) => {
  const link = document.createElement('a');
  link.href = targetLink;
  link.download = fileName;
  document.body.appendChild(link);
  link.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    }),
  );
  document.body.removeChild(link);
};

export const addPlaidLinkCallbackOnEvent = (customer: any, metadata: any) => {
  const data = {
    Customer_PK: customer?.Customer_PK,
    Metadata_account_number_mask: metadata.account_number_mask,
    Metadata_error_type: metadata.error_type,
    Metadata_error_code: metadata.error_code,
    Metadata_error_message: metadata.error_message,
    Metadata_exit_status: metadata.exit_status,
    Metadata_institution_id: metadata.institution_id,
    Metadata_institution_name: metadata.institution_name,
    Metadata_institution_search_query: metadata.institution_search_query,
    Metadata_is_update_mode: metadata.is_update_mode,
    Metadata_match_reason: metadata.match_reason,
    Metadata_routing_number: metadata.routing_number,
    Metadata_view_name: metadata.view_name,
    Metadata_request_id: metadata.request_id,
    Metadata_link_session_id: metadata.link_session_id,
    Metadata_timestamp: metadata.timestamp,
    Metadata_selection: metadata.selection,
  };

  addPlaidLinkCallback({ data, type: 'onEvent' });
};

export const addPlaidLinkCallbackOnExit = (
  customer: any,
  error: any,
  metadata: any,
) => {
  const data = {
    Customer_PK: customer?.Customer_PK,
    Metadata_institution_name: metadata.institution?.name || null,
    Metadata_institution_id: metadata.institution?.institution_id || null,
    Metadata_status: metadata.status,
    Metadata_link_session_id: metadata.link_session_id,
    Metadata_request_id: metadata.request_id,
    Metadata_error_type: error?.error_type || null,
    Metadata_error_code: error?.error_code || null,
    Metadata_error_message: error?.error_message || null,
    Metadata_display_message: error?.display_message || null,
  };

  addPlaidLinkCallback({ data, type: 'onExit' });
};

export const addPlaidLinkCallbackOnSuccess = (customer: any, metadata: any) => {
  const data = {
    Customer_PK: customer?.Customer_PK,
    Metadata_institution_name: metadata.institution?.name || null,
    Metadata_institution_id: metadata.institution?.institution_id || null,
    Metadata_accounts_id: metadata.account?.id || null,
    Metadata_accounts_name: metadata.account?.name || null,
    Metadata_accounts_mask: metadata.account?.mask || null,
    Metadata_accounts_type: metadata.account?.type || null,
    Metadata_accounts_subtype: metadata.account?.subtype || null,
    Metadata_accounts_verification_stats:
      metadata.account?.verification_status || null,
  };

  addPlaidLinkCallback({ data, type: 'onSuccess' });
};
